import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const LeafIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path d="M4.29999 19.7C4.49999 19.9 4.69999 20 4.99999 20C5.29999 20 5.49999 19.9 5.69999 19.7L7.49999 17.9C8.39999 18.3 9.69999 18.7 11.1 18.7C12.7 18.7 14.4 18.2 16 16.7C19.4 13.3 20 5.4 20 5.1C20 4.8 19.9 4.5 19.7 4.3C19.5 4.1 19.2 4 18.9 4C18.6 4 10.5 4.8 7.29999 8C5.29999 10 4.99999 12.4 5.39999 14.4L11.4 11.1L4.19999 18.3C3.89999 18.7 3.89999 19.3 4.29999 19.7Z" />
    </Icon>
  );
};
